function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.4 1.6h14.957v13.13H.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.792 1.6c-3.377 0-6.165 2.564-6.524 5.848L1.061 6.411a.4.4 0 0 0-.522.607l1.87 1.605a.399.399 0 0 0 .528-.006l1.785-1.605a.4.4 0 1 0-.534-.595l-1.105.993c.37-2.822 2.786-5.01 5.71-5.01a5.771 5.771 0 0 1 5.764 5.765 5.771 5.771 0 0 1-5.765 5.765.4.4 0 1 0 0 .8 6.572 6.572 0 0 0 6.565-6.565A6.572 6.572 0 0 0 8.792 1.6",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.792 4.589a.4.4 0 0 0-.4.4v4.11a.4.4 0 0 0 .4.4h2.613a.4.4 0 1 0 0-.8H9.192V4.99a.4.4 0 0 0-.4-.4",
  fill: "#000"
}));
const SvgExpiration = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpiration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expiration.a6f317b7.svg";
export { ForwardRef as ReactComponent };